/* ============================================================
   Vantor — app-250 builder behaviour (theme port, app-251).
   Flow: truck (8) → bed length → Cap window (THE GATE) → tent / add-ons.
   app-240: prices, deposit and remainder come from Vantor.quote() on Shopify data.
   Matrix is window × tent (app-238, Jerry 2026-09-23). A Builder add-on is a
   price / cart line only — it never changes the plate image.
   TPC-168: the add-on rows come from Vantor.addons(), one per product whose Builder
   add-on field is on. This file names no add-on product.
   TPC-1141: truck + actual bed is the Cap's Fitment (Vantor.fitmentOf), never the bed's band.
   The Topper Storage Box row is the Cap's Storage option: ticking it chooses another Cap variant.
   TPC-1175: the Rooftop Tent is added here only beside the exact Cap when both are in stock. Otherwise its
   switch is cleared and disabled, with the reason once a Cap is chosen, and nothing ticks it again. Its own
   page still sells it.

   Plate id form:  <FAMILY>-<W><T><S>
     W       H = Hardshell, S = Sliding
     T       1 = Rooftop Tent on, 0 = off
     S       always 0 — the storage digit is retired, kept so the id form stays stable
   → 4 plates per family × 2 × 2: H00 H10 S00 S10.
     e.g. Silverado + Sliding + tent = BLD-SIL-S10
   Families come from CATALOG.trucks[].family (app-238) — this file never branches on a
   truck id and never lists families, so a new family is a catalog + boot-map change only.
   ============================================================ */
(function (V) {
  var main = document.querySelector('[data-builder]'); if (!main) return;
  var $ = function (s) { return main.querySelector(s); };
  var val = function (name) { var i = main.querySelector('input[name="' + name + '"]:checked'); return i ? i.value : null; };
  var bedsFor = null;   // truck id the bed options are currently painted for

  // step 02 options follow the chosen truck. One bed (Gladiator) = chosen for the shopper.
  function paintBeds(truck, want) {
    var box = $('[data-beds]'), legend = '<legend class="visually-hidden">Bed length</legend>';
    bedsFor = truck ? truck.id : null;
    if (!truck) { box.innerHTML = legend + '<span class="seg__hint">Select a truck first</span>'; return; }
    box.innerHTML = legend + truck.beds.map(function (b) {
      var on = b.id === want || truck.beds.length === 1;
      return '<label class="seg__opt"><input type="radio" name="bed" value="' + b.id + '"' + (on ? ' checked' : '') + '>' +
        '<span class="seg__face">' + b.label + ' bed<small>Cap ' + capLabel(b.length) + '</small></span></label>';
    }).join('');
  }
  function capLabel(lengthId) {
    var l = V.CATALOG.cap.lengths.find(function (x) { return x.id === lengthId; });
    return l ? l.label : lengthId;
  }

  // review deep links: ?truck=silverado&bed=6.6&window=sliding&gear=tent,storage
  // (tent= is an inventory flag). gear names the tent, installed storage and each add-on by its key.
  var q = new URLSearchParams(location.search);
  var gear = (q.get('gear') || '').split(',');

  // steps 05 and up: one checkbox row per Builder add-on. A product title is text, so it is escaped.
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var addonRows = function () { return main.querySelectorAll('[data-row="addon"]'); };
  var painted = Object.create(null);   // add-on keys that have had a row
  var storageOn = gear.indexOf('storage') !== -1;
  function paintAddons() {
    var on = Object.create(null);
    addonRows().forEach(function (row) { var i = row.querySelector('input'); on[i.value] = i.checked; });
    var box = $('input[name="storage"]');
    if (box) storageOn = box.checked;
    var rows = [{ row: 'storage', name: 'storage', kind: 'storage', title: V.CATALOG.storage.name, checked: storageOn }]
      .concat(V.addons().map(function (a) {
        var checked = painted[a.kind] ? on[a.kind] : gear.indexOf(a.kind) !== -1;
        painted[a.kind] = true;
        return { row: 'addon', name: 'addon', kind: a.kind, title: a.title, price: V.money(a.price) + ' · ', checked: checked };
      }));
    $('[data-addons]').innerHTML = rows.map(function (a, n) {
      return '<div class="fit-row fit-row--top" data-row="' + a.row + '">' +
        '<div class="fit-label"><span class="fit-step">' + String(5 + n).padStart(2, '0') + '</span>' +
          '<span class="fit-label__text">Add-on</span><span class="fit-label__helper">Optional</span></div>' +
        '<div class="fit-control">' +
          '<label class="check"><input type="checkbox" name="' + a.name + '" value="' + esc(a.kind) + '"' + (a.checked ? ' checked' : '') + '>' +
            '<span class="check__text">Add ' + esc(a.title) + '<small><span data-addon-price>' + (a.price || '') + '</span>Not shown in preview</small></span>' +
            '<span class="check__box" aria-hidden="true"><svg class="check__mark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="#C9BBA8" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '</label>' +
          '<p class="fit-note" data-addon-blocked hidden>Sold out.</p>' +
        '</div></div>';
    }).join('');
  }

  var capFlag = document.documentElement.getAttribute('data-inv-cap');

  // TPC-1145: a Sliding plate illustrates the truck family, so its alt names the family's own truck and never a bed length
  function slidingAlt(truck, tentOn) {
    var owner = V.CATALOG.trucks.find(function (t) { return t.family === truck.family && !t.shared; }) || truck;
    return 'Illustrative ' + owner.make + ' ' + owner.model + ' truck with Sliding-window Cap, ' +
      (tentOn ? 'open wedge roof tent' : 'no roof tent') + '.';
  }

  function paint() {
    var truck = V.CATALOG.trucks.find(function (t) { return t.id === val('truck'); });
    if ((truck ? truck.id : null) !== bedsFor) paintBeds(truck, null);   // truck changed → bed choice resets
    var bed = truck && truck.beds.find(function (b) { return b.id === val('bed'); });
    var win = V.CATALOG.cap.windows.find(function (w) { return w.id === val('window'); });
    var name = truck ? truck.make + ' ' + truck.model : '';

    // ---- add-on gate (app-238, Jerry 2026-09-24): the tent and every add-on stay disabled and off
    // until truck + bed + Cap window are chosen — an add-on has nothing to mount on before that.
    var ready = !!(bed && win);
    var fitment = bed ? V.fitmentOf(truck.id, bed.id) : null;

    // a row is addable when in stock, or out of stock on a selling plan
    var addons = V.addons(), picked = [];
    addonRows().forEach(function (row) {
      var input = row.querySelector('input');
      var addon = addons.find(function (a) { return a.kind === input.value; });
      var addable = addon.state !== 'out';
      input.disabled = !addable || !ready;
      if (!addable || !ready) input.checked = false;
      row.querySelector('[data-addon-blocked]').hidden = addable;   // the Sold-out note is about stock, not the gate
      row.classList.toggle('fit-row--gated', !ready);
      if (input.checked) picked.push(addon);
    });
    $('[data-row="tent"]').classList.toggle('fit-row--gated', !ready);

    var storage = ready ? V.capStorage({ fitment: fitment, window: win.id }) : { price: null, state: null };
    var storageRow = $('[data-row="storage"]'), box = storageRow.querySelector('input');
    var storageAddable = storage.state !== null && storage.state !== 'out';
    box.disabled = !storageAddable || !ready;
    if (box.disabled) box.checked = false;
    storageRow.querySelector('[data-addon-blocked]').hidden = storage.state !== 'out';
    storageRow.querySelector('[data-addon-price]').textContent = storage.price === null ? '' : '+' + V.money(storage.price) + ' · ';
    storageRow.classList.toggle('fit-row--gated', !ready);
    storageOn = box.checked;
    var cap = ready ? { fitment: fitment, window: win.id, storage: storageOn } : null;
    var capVariant = cap && V.variantFor('cap', cap);

    var tentInput = $('input[name="tent"]'), tentWhy = $('[data-tent-blocked]');
    var tentState = V.stateOf(V.variantFor('tent')), capState = capVariant ? V.stateOf(capVariant) : null;
    var reason = !capVariant ? '' : tentState !== 'in' ? 'Sold out.' : capState !== 'in' ? 'Only with an in-stock Cap.' : '';
    tentInput.disabled = !capVariant || reason !== '';
    if (tentInput.disabled) tentInput.checked = false;
    tentWhy.textContent = reason;
    tentWhy.hidden = reason === '';
    var tentOn = tentInput.checked;

    // ---- window gate: no configured image until truck + bed AND Cap window are chosen
    var face = !bed ? 'fitment' : !win ? 'window' : 'plate';
    main.querySelectorAll('[data-face]').forEach(function (n) { n.hidden = n.getAttribute('data-face') !== face; });
    $('[data-row="bed"]').classList.toggle('fit-row--gated', !truck);
    $('[data-row="window"]').classList.toggle('fit-row--gated', !bed);
    $('[data-fitment-t]').textContent = truck ? 'Choose your bed length' : 'Select your truck';
    $('[data-fitment-d]').textContent = truck ? name + '. The bed length sets your Cap length.' : 'Eight supported trucks. Pick yours, then the bed length.';

    if (face === 'plate') {
      // app-245 Argus FAIL #3: no plate-id / meta overlay — img swap + its captions only
      // the id comes from V.plateId, which takes no add-on: none changes the image
      var plateId = V.plateId(truck, win, tentOn);
      var sliding = win.code === 'S';
      $('[data-plate-rep]').hidden = !truck.shared || sliding;
      $('[data-plate-caption]').hidden = !sliding;
      var plateImg = $('[data-plate-img]');
      if (plateImg) {
        var map = (window.VantorAssets && window.VantorAssets.plates) || {};
        var nextSrc = map[plateId];
        if (!nextSrc && window.VantorAssets && window.VantorAssets.bld) {
          nextSrc = window.VantorAssets.bld.replace(/BLD-[A-Z0-9-]+\.jpg/, plateId + '.jpg');
        }
        if (!nextSrc) nextSrc = plateId + '.jpg';
        if (plateImg.getAttribute('src') !== nextSrc) plateImg.setAttribute('src', nextSrc);
        plateImg.setAttribute('alt', sliding ? slidingAlt(truck, tentOn) : [name + ' ' + bed.label + ' bed', win.label,
          'Tent ' + (tentOn ? 'on' : 'off')].join(', ') +
          (truck.shared ? ' (representative truck shown)' : ''));
      }
    }

    $('[data-done]').textContent = String((truck ? 1 : 0) + (bed ? 1 : 0) + (win ? 1 : 0)).padStart(2, '0') + ' / 03 required';
    $('[data-build-name]').textContent = bed ? name + ' · ' + bed.label + ' bed' : truck ? name : 'Your build';

    // app-240: the pills follow the Cap variant this truck + bed + window + storage resolves to.
    if (capVariant) V.setFlag('cap', V.stateOf(capVariant));
    else if (capFlag !== null) document.documentElement.setAttribute('data-inv-cap', capFlag);

    if (!bed || !win) {
      var blocked = !truck ? 'Select your truck' : !bed ? 'Choose a bed length' : 'Choose a Cap window';
      V.paintSummary(null, { cfg: !truck ? 'No truck selected' : !bed ? 'Bed length not chosen' : 'Cap window not chosen', blocked: blocked });
      return;
    }
    V.paintSummary(V.quote({ cap: cap, tent: tentOn, addons: picked.map(function (a) { return a.kind; }) }),
      { cfg: 'Cap ' + win.label + (tentOn ? ' + Tent' : '') + (storageOn ? ' + ' + V.CATALOG.storage.name : '') +
        picked.map(function (a) { return ' + ' + a.title; }).join('') });
  }

  main.addEventListener('change', paint);
  document.addEventListener('vantor:state', paint);

  // app-236 deep links still resolve: ?fit=tac-6 etc.
  // A query value is never interpolated into a selector — it is matched against input.value instead.
  var LEGACY = { 'tac-5': ['tacoma', '5'], 'tac-6': ['tacoma', '6'], 'f15-55': ['f-series', '5.5'], 'f15-65': ['f-series', '6.5'] };
  // own property only: ?fit=constructor / ?fit=__proto__ must not resolve through
  // Object.prototype and swallow the ?truck= / ?bed= pair.
  var fit = q.get('fit');
  var want = (fit && Object.prototype.hasOwnProperty.call(LEGACY, fit)) ? LEGACY[fit] : [q.get('truck'), q.get('bed')];
  function check(name, value) {
    var hit = null;
    main.querySelectorAll('input[name="' + name + '"]').forEach(function (i) { if (i.value === value) hit = i; });
    if (hit) hit.checked = true;
    return hit;
  }
  var wantTruck = V.CATALOG.trucks.find(function (x) { return x.id === want[0]; });
  if (wantTruck && check('truck', wantTruck.id)) {
    var wantBed = wantTruck.beds.find(function (b) { return b.id === want[1]; });
    paintBeds(wantTruck, wantBed ? wantBed.id : null);
  }
  var wantWin = V.CATALOG.cap.windows.find(function (x) { return x.id === q.get('window'); });
  if (wantWin) check('window', wantWin.id);
  if (q.get('gear')) $('input[name="tent"]').checked = gear.indexOf('tent') !== -1;
  paintAddons();
  paint();
  // a collection of more than 250 products: the rows of each later page join when the walk is done
  V.loadAddons(function () {
    if (V.addons().length === addonRows().length) return;
    paintAddons();
    paint();
  });
})(window.Vantor);
